import RawSVG from 'react-inlinesvg';

const SVG = RawSVG as unknown as React.FC<{
	src: string;
	width: number | string;
	height: number | string;
	title?: string;
	preProcessor?: (code: string) => string;
}>;

export default SVG;
